import { observer } from 'mobx-react';
import * as React from 'react';
import { inject } from '../../../utils/decorators';
import VorgangFormularElement from '../VorgangFormularElement';
import { AuftragStore } from '../../../stores/AuftragStore';
import { ApiStore } from '../../../stores/ApiStore';
import { BpsReferenzkraftKalibrierungStore, IBpsReferenzkraftRolleMessung } from '../../../stores/BpsReferenzkraftKalibrierungStore';
import BpsReferenzkraftObjektInfo from './BpsReferenzkraftObjektInfo';
import { IObjekt } from '../../../models/ApiTypes';
import BpsReferenzkraftRollenDurchmesser from './BpsReferenzkraftRollenDurchmesser';
import BpsReferenzkraftRollensaetze from './BpsReferenzkraftRollensaetze';
import { FormControl } from 'react-bootstrap';
import BpsPruefortParameter from './BpsPruefortParameter';
import BpsReferenzkraftWaegezelle from './BpsReferenzkraftWaegezelle';
import BpsReferenzkraftDrehzahlSchlupf from './BpsReferenzkraftDrehzahlSchlupf';
import BpsReferenzkraftKMGInfo from './BpsReferenzkraftKMGInfo';

export interface IBpsReferenzkraftkalibrierungProps {
  elementguid: string;
  kategorieguid: string;
  editable?: boolean;
  value?: string;
  element: VorgangFormularElement;
}

/**
 * Kapselkomponemnte für die BPS Kalibrierung nach Referenzkraftverfahren
 */
@observer
export default class BpsReferenzkraftKalibrierung extends React.Component<IBpsReferenzkraftkalibrierungProps, {}> {

  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungStore) kalibrierungStore: BpsReferenzkraftKalibrierungStore;

  constructor(props: IBpsReferenzkraftkalibrierungProps) {
    super(props);
    this.kalibrierungStore.clear();
  }

  async componentDidMount() {
    // Zu betrachtenden BPS aus Auftrag ermitteln
    let objekt: IObjekt | undefined = undefined;
    let auftrag = this.auftragStore.auftrag;
    if (auftrag) {
      for (var obj of auftrag.objekte) {
        if (obj.typ.toLocaleLowerCase() === 'bps') {
          objekt = obj;
          break;
        }
      }
    }
    this.kalibrierungStore.setKalibrierGegenstand(objekt);
    if (objekt) {
      const objektVorlage = await this.apiStore.objektVorlage(objekt.objektguid);
      if (objektVorlage.ok) {
        this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
      }
    }
    // Gespeicherte Messung übernehmen
    if (this.props.value) {
      let messung: IBpsReferenzkraftRolleMessung = this.kalibrierungStore.datensatz;
      messung = JSON.parse(this.props.value) as IBpsReferenzkraftRolleMessung;
      this.kalibrierungStore.setMesswerte(messung);
    }
    this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
  }

  render() {
    return (
      <div>
        <BpsReferenzkraftObjektInfo/>
        <BpsReferenzkraftKMGInfo/>
        {this.kalibrierungStore.objektVorlage ?
          <div>
            <BpsPruefortParameter titel="Prüfortparameter zu Beginn der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.beginn}/>
            <BpsReferenzkraftRollenDurchmesser/>
            <BpsReferenzkraftWaegezelle/>
            <BpsReferenzkraftRollensaetze/>
            <BpsReferenzkraftDrehzahlSchlupf/>
            <BpsPruefortParameter titel="Prüfortparameter am Ende der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.ende}/>
          </div>
          :
          <div>
            Rufe Objektvorlage ab...
          </div>
        }
        {/* Kompletten Messdatensatz als verstecktes Feld im Request übergeben */}
        <FormControl type="hidden" name={`${this.props.kategorieguid}[${this.props.elementguid}][json]`} value={JSON.stringify(this.kalibrierungStore.datensatz)}/>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/BpsReferenzkraftKalibrierung.tsx